module.exports = __webpack_public_path__ + "img/we-will-fix-it.4ca55a24.jpeg";